import { createSlice } from '@reduxjs/toolkit';
import { CIDS, ROWS_PER_PAGE, SORT_DIRECTIONS } from './constants';

const INITIAL_SORT_ORDER = {
	name: CIDS.RANK,
	direction: SORT_DIRECTIONS.ASC
};

const productsTableSlice = createSlice({
	name: 'productsTable',
	initialState: {
		rowsPerPage: ROWS_PER_PAGE[0],
		sortOrder: INITIAL_SORT_ORDER
	},
	reducers: {
		resetRowsPerPage: state => {
			state.rowsPerPage = ROWS_PER_PAGE[0];
		},
		updateRowsPerPage: (state, action) => {
			state.rowsPerPage = action.payload;
		},
		resetSortOrder: (state, action) => {
			state.sortOrder = { name: 'rank', direction: 'asc' };
		},
		updateSortOrder: (state, action) => {
			const direction = action.payload.direction;
			if (direction === 'none') {
				state.sortOrder = { name: 'rank', direction: 'asc' };
			} else {
				state.sortOrder = action.payload;
			}
		}
	}
});

export const { resetRowsPerPage, updateRowsPerPage, resetSortOrder, updateSortOrder } = productsTableSlice.actions;
export default productsTableSlice.reducer;
